<template>
  <div
    :dependentComputedProps="{
      isSessionPresent,
    }"
  >
    <div
      class="static-pg-header"
      :class="[!isDesktop ? 'plr16 ' : 'd-flex w-auto']"
    >
      <i
        v-if="isOnOffersPage"
        class="hkfi-back dt-hand"
        @click="triggerBack"
      ></i>
      <span class="title">Offers</span>
      <!-- <div class="fs-11 color-slaty pl20">
        <span v-if="cartQuantity" class="cart-quantity pr4"
          >{{ cartQuantity }}
          <span>{{ cartQuantity > 1 ? "Items" : "Item" }}</span></span
        >
        <span v-if="cartQuantity && displayNetPrice" class="color-border"
          >|</span
        >
        <span class="cart-quantity pl4" v-if="displayNetPrice"
          ><span class="rs" v-if="Number(displayNetPrice) > 0">Rs.</span
          >{{ displayNetPrice }}</span
        >
      </div> -->
      <i
        v-if="isDesktop && !isOnOffersPage"
        @click.stop="closeOffersWrapper($event)"
        class="hkfi-close dt-mla-auto hand fs-22"
      ></i>
    </div>
    <div v-if="isCartSelected" class="pb12 plr16 dt-pc">
      <!-- <h1 class="fs-14 bold">Offers for You</h1>
          <p class="fs-12 color-light-grey">
            Enter a coupon and add items to your cart
          </p> -->
      <div class="searchblock" :class="{ 'border-red': offerFailedMsg }">
        <input
          class="enter-coupon"
          id="searchQueryInput"
          type="text"
          name="searchQueryInput"
          placeholder="Enter coupon code"
          v-on:keyup="enableApply"
        />
        <div v-if="offerFailedMsg">
          <i class="hkfi-close fs-18" @click="clearSearchInput"></i>
        </div>
        <button
          v-if="!offerFailedMsg"
          class="medium fs-14"
          :class="[
            isApplyEnabled
              ? 'enabledButtonSearchOffer'
              : 'disabledButtonSearchOffer',
          ]"
          @click="triggerOfferAppliedModal($event)"
        >
          Apply
        </button>
      </div>
      <p
        v-if="offerFailedMsg && failedOfferPromo === manualOffer"
        class="fs-12 error-msg"
      >
        {{ offerFailedMsg }}
      </p>
    </div>
    <div :class="{ 'offer-listing-modal': isDesktop }">
      <div class="list-lft" :class="[!isDesktop ? 'plr16' : '']">
        <!-- All Coupons  -->
        <div v-if="welcomeOffers?.length" class="pb24 dt-plr24">
          <div
            v-for="(offerList, index2) in welcomeOffers"
            :key="offerList?.category"
            class="aligncenter pt12"
          >
            <div class="fs-16 bold">{{ offerList?.displayTitle }}</div>
            <div
              v-for="(item, index) in offerList?.data"
              :key="item?.campaignId"
              class="aligncenter pt12"
            >
              <offer-listing-card
                :data-index="index"
                :data-promo-code="item.couponCode"
                :data-title="item.metaData?.name"
                :data-display-message="item.metaData?.description"
                :data-text="item.metaData?.savingsMessage"
                :data-action="
                  appliedOfferPromo == item.couponCode
                    ? isCartSelected
                      ? 'Remove'
                      : 'Unselect'
                    : isCartSelected
                    ? 'Apply'
                    : 'Select'
                "
                :data-item-tnc="item.campaignId"
                :data-selected-offer="selectedOffer?.couponCode"
                :data-section-position="index2 + 1"
                :data-offer-not-valid="
                  offerFailedMsg && failedOfferPromo == item.couponCode
                "
                :data-is-applicable="item?.applicable"
                :data-bottom-msg="getBottomMsg(item)"
              >
              </offer-listing-card>
              <p
                v-if="offerFailedMsg && failedOfferPromo == item.couponCode"
                class="fs-12 error-msg"
              >
                {{ offerFailedMsg }}
              </p>
            </div>
          </div>
        </div>

        <!-- @TODO:  payment offers does not exist in hongs for now, implemented as per dominos , new api for payment offers has been integrated- with stores 
        <div v-if="paymentOffers?.length" class="pb24 dt-plr24">
          <div class="fs-16 bold">Payment Offers</div>
          <div
            v-for="(item, index) in paymentOffers"
            :key="item?.id"
            class="aligncenter pt12"
          >
            <offer-listing-card
              :data-index="index"
              :data-logo="item.iconUrl"
              :data-title="item.metaData.name"
              :data-display-message="item.metaData.description"
              :data-text="item.metaData?.savingsMessage"
              :data-offer-list="item.offerlist"
              :data-expiry-date="item?.expiryDate"
              :data-action="'Apply'"
              :data-offer-type="'Payment Offer'"
            >
            </offer-listing-card>
          </div>
        </div> -->
      </div>
      <div class="list-rgt" :class="[!isDesktop ? 'plr16' : '']">
        <!-- for desktop view - showing offer details content without popup -->
        <offer-details-flat-content
          v-if="isDesktop"
          :data-title="selectedOffer?.metaData?.name"
          :data-description="selectedOffer?.metaData?.description"
          :data-coupon-code="selectedOffer?.couponCode"
          :data-item-tnc="selectedOffer?.campaignId"
          :data-is-applicable="selectedOffer?.applicable"
          :data-expiry-date="''"
        ></offer-details-flat-content>
        <!-- for pwa view - offer details popup -->
        <offer-details-popup
          v-if="!isDesktop && offerDetailsModalFlag"
          :data-title="selectedOffer?.metaData?.name"
          :data-description="selectedOffer?.metaData?.description"
          :data-coupon-code="selectedOffer?.couponCode"
          :data-savings-msg="selectedOffer?.metaData?.savingsMessage"
          :data-expiry-date="''"
        ></offer-details-popup>
      </div>
    </div>
    <div class="no-addr pt20" v-if="!isLoading && !welcomeOffers.length">
      <div class="no-addr-icon-body tc">
        <div class="sliding-container">
          <img
            :src="staticImgBaseUrl + '/images/global/momos.svg'"
            class="static-no-offers-image"
            :class="{ top32: !isCartSelected }"
          />
          <div class="sliding-background"></div>
        </div>
      </div>
      <div class="fs-14 bold title lh21 tc plr50">
        Uh Oh! We don't have any offers available right now..
      </div>
      <div class="fs-12 title tc plr40 pt5 color-grey-light">
        Why don't you try out our most popular pre discounted items?
      </div>
    </div>
  </div>
</template>
<script>
import { defineAsyncComponent } from "vue";
import Utility from "../helpers/utility";
import LocalStorageFunc from "../helpers/localStorageFunc";
import { staticImgBaseUrl, clientPlatform } from "../config/apiEndpoints";
import {
  keyMapsAction,
  keyMapsGetter,
  keyMapsMutation,
} from "../helpers/storeKeys";
import { EVENT_CLICK_APPLYMANUALCOUPONFAILURE } from "../helpers/analyticsEvents";

export default {
  components: {
    OfferListingCard: defineAsyncComponent(() =>
      import("./OfferListingCard.vue")
    ),
    OfferDetailsPopup: defineAsyncComponent(() =>
      import("./OfferDetailsPopup.vue")
    ),
    OfferDetailsFlatContent: defineAsyncComponent(() =>
      import("./OfferDetailsFlatContent.vue")
    ),
  },
  name: "OffersListingPage",
  data() {
    return {
      clientPlatform,
      isApplyEnabled: false,
      parsedResults: [],
      staticImgBaseUrl,
    };
  },
  mounted() {
    document.body.classList.remove("body-stop-scroll-mobile");
    this.$store.commit(keyMapsMutation.UPDATE_LOADING_STATE, true);
    setTimeout(
      () => this.$store.commit(keyMapsMutation.UPDATE_LOADING_STATE, false),
      3000
    );
    this.$store.commit(
      keyMapsMutation.UPDATE_APPLIED_COUPON_PROMO,
      LocalStorageFunc.getCouponCode()?.code
    );
    this.parsedResults = Utility.getCartDataInMenuServiceFormat(
      LocalStorageFunc.getCart()
    );
    this.processResultDataForStore(this.parsedResults);
  },
  methods: {
    processResultDataForStore(data) {
      this.$store.commit(keyMapsMutation.UPDATE_PRODUCTS_IN_STORE, data);
      this.$store.commit(keyMapsMutation.LOAD_CART_FROM_STORAGE_SERVICE, {});
    },
    triggerBack(e) {
      if (this.isCartSelected) {
        LocalStorageFunc.setPrevUrl("");
        Utility.sendToCartScreen();
      } else {
        Utility.redirectToHomeOrRedirectUrl();
      }
    },
    enableApply() {
      let i = document.getElementById("searchQueryInput");
      if (i.value.length > 0) {
        this.isApplyEnabled = true;
      } else {
        this.isApplyEnabled = false;
      }
    },

    triggerOfferAppliedModal(event) {
      if (this.isApplyEnabled) {
        let couponCode = document.getElementById("searchQueryInput").value;

        event?.stopPropagation();
        this.$store.dispatch(keyMapsAction.APPLY_OFFER_API, {
          couponCode: couponCode,
          source: "MANUAL",
        });

        if (this.offerFailedMsg) {
          setTimeout(() => {
            this.$store.commit(keyMapsMutation.UPDATE_OFFER_FAILED_MSG, "");
          }, 1000);
        } else {
          // this.clearSearchInput();
        }
      }
    },
    closeAppliedModal(event) {
      document.body.classList.remove("body-stop-scroll-mobile");
      this.$store.commit(keyMapsMutation.UPDATE_OFFER_APPLY_MODAL, false);
      this.$store.commit(
        keyMapsMutation.UPDATE_OFFER_DETAILS_MODAL_FLAG,
        false
      );
    },

    closeOfferDetailsModal(source) {
      document.body.classList.remove("body-stop-scroll-mobile");
      this.$store.commit(
        keyMapsMutation.UPDATE_OFFER_DETAILS_MODAL_FLAG,
        false
      );
      if (window.location.href?.includes("/offers")) {
        Utility.updateOfferUrl();
      }
    },
    clearSearchInput() {
      document.getElementById("searchQueryInput").value = "";
      this.isApplyEnabled = false;
      this.$store.commit(keyMapsMutation.UPDATE_OFFER_FAILED_MSG, "");
    },
    closeOffersWrapper() {
      document.body.classList.remove("body-stop-scroll-mobile");
      this.$store.commit(
        keyMapsMutation.UPDATE_INIT_OFFER_LISTING_WRAPPER,
        false
      );
      this.$store.commit(keyMapsMutation.UPDATE_OFFER_FAILED_MSG, "");
      this.$store.commit(keyMapsMutation.UPDATE_SELECTED_OFFER, {});
    },
    getBottomMsg(offersData) {
      // Check if offer is applicable
      if (offersData.applicable) {
        // Check if there's an expiry timer
        if (
          offersData.expiryTimer &&
          offersData.expiryTimer.endTime !== 0 &&
          offersData.expiryTimer.endTime > Date.now() &&
          offersData.expiryTimer.showTimerBefore <= Date.now()
        ) {
          if (
            offersData.labelType &&
            offersData.labelType === "General_Milestone" &&
            offersData.offerOptions
          ) {
            // MilestoneCouponBar logic
            return ""; //Todo
          } else {
            return `Coupon expires in 
              ${Utility.formatTimestampOffer(
                offersData.expiryTimer?.endTime -
                  offersData.expiryTimer?.showTimerBefore
              )}`;
          }
        }

        // General Milestone without expiryTimer
        if (
          offersData.labelType &&
          offersData.labelType === "General_Milestone" &&
          offersData.offerOptions
        ) {
          return ""; //Todo
        }

        // Payment offer with message
        if (
          offersData.paymentOffersMetadata?.paymentId &&
          offersData.messages &&
          offersData.messages[0]?.messageType &&
          offersData.messages[0]?.messageType.toLowerCase() === "nudge" &&
          offersData.messages[0]?.message
        ) {
          return offersData.messages[0].message;
        }
      } else if (
        !offersData.applicable &&
        offersData.messages &&
        offersData.messages[0]?.messageType &&
        offersData.messages[0]?.messageType.toLowerCase() === "error" &&
        offersData.messages[0]?.message
      ) {
        return offersData.messages[0]?.message;
      }

      return ""; // Fallback case
    },
  },
  computed: {
    isDesktop() {
      return Utility.isDesktop();
    },
    welcomeOffers() {
      return this.$store.state.Offers.welcomeOffers;
    },
    offerFailedMsg() {
      return this.$store.state.Offers.offerFailedMsg;
    },
    paymentOffers() {
      return this.$store.state.PaymentOffers.paymentOffers;
    },
    selectedPaymentOfferTnc() {
      return this.$store.state.PaymentOffers.selectedPaymentOfferTnc;
    },
    topCouponIndex() {
      return this.$store.state.Offers.topCouponIndex;
    },
    offerDetailsModalFlag() {
      return this.$store.state.Offers.offerDetailsModalFlag;
    },
    selectedOfferTnc() {
      return this.$store.state.Offers.selectedOfferTnc;
    },
    selectedOffer() {
      return Utility.isDesktop()
        ? this.$store.state.Offers.selectedOffer &&
          Object.keys(this.$store.state.Offers.selectedOffer).length
          ? this.$store.state.Offers.selectedOffer
          : this.appliedOfferPromo
          ? this.offersList.find((i) => i.couponCode == this.appliedOfferPromo)
          : this.welcomeOffers[0]?.data[0]
        : this.$store.state.Offers.selectedOffer;
    },
    isCartSelected() {
      return LocalStorageFunc.getPrevUrl().includes("/cart");
    },
    isOnOffersPage() {
      return Utility.isCurrentlyAtUrl("/offers");
    },
    appliedOfferPromo() {
      return this.$store.state.Offers.appliedOfferPromo;
    },
    failedOfferPromo() {
      return this.$store.state.Offers.failedOfferPromo;
    },
    manualOffer() {
      return this.$store.state.Offers.manualOffer;
    },
    isSessionPresent() {
      let isSessionP = this.$store.state.Auth.isSessionPresent;
      if (isSessionP) {
        this.$store.dispatch(
          keyMapsAction.WELCOME_OFFER_API,
          this.isCartSelected ? false : true
        );
      }
      return isSessionP;
    },
    isLoading() {
      return this.$store.state.Loader.isLoading;
    },
    offersList() {
      return this.$store.state.Offers.offersList;
    },
    cartQuantity() {
      return this.$store.getters[keyMapsGetter.CART_QUANTITY];
    },
    displayNetPrice() {
      return this.$store.state.Global.displayNetPrice;
    },
  },
};
</script>
<style></style>
